export const TAG_ACTION_START = 'TAG_ACTION_START';
export const TAG_ACTION_ERROR = 'TAG_ACTION_ERROR';
export const GET_ALL_TAGS = 'GET_ALL_TAGS';
export const GET_TAG = 'GET_TAG';
export const CREATE_TAG = 'CREATE_TAG';
export const UPDATE_TAG = 'UPDATE_TAG';
export const DELETE_TAG = 'DELETE_TAG';

export const tagActionStart = () => ({ type: TAG_ACTION_START });
export const tagActionError = (error: any) => ({ type: TAG_ACTION_ERROR, payload: error });
export const getAllTagsAction = (tags: any[]) => ({ type: GET_ALL_TAGS, payload: tags });
export const getTagAction = (tag: any) => ({ type: GET_TAG, payload: tag });
export const createTagAction = (tag: any) => ({ type: CREATE_TAG, payload: tag });
export const updateTagAction = (tag: any) => ({ type: UPDATE_TAG, payload: tag });
export const deleteTagAction = (id: string) => ({ type: DELETE_TAG, payload: id }); 